<template>
  <div class="address-picker-mask" @click="onCloseCenter">
      <div class="address-picker" @click="stopPropagation">
          <div class="header">
              <a href="javascript:void(0)" @click="onCloseCenter" class="pull-left">取消</a>
              选择学习中心
          </div>
          <div class="content">
            <ul class="left-nav">
                <li 
                  v-if="myClosest.length > 0"
                  @click="onAreaChange({id: -1})"
                  :class="['list-item', {'selected': areaId == -1}]"
                  key="-1">
                    离我最近
                </li>
                <li v-for="schoolArea in areaList" 
                    @click="onAreaChange(schoolArea)"
                    :class="['list-item', {'selected': areaId == schoolArea.id}]"
                    :key="schoolArea.id">
                        {{schoolArea.name}}
                </li>
            </ul>
            <div class="right-content">
                <ul>
                  <li v-for="school in schools" 
                      @click="onSchoolChange(school)"
                      :class="['list-item', {'selected': schoolId == school.id}]"
                      :key="school.schoolId">
                        {{school.name}}
                      <span class="distance-sp">{{school.distinctText}}</span>
                      <p class="address-detail">{{school.address}}</p>
                  </li>
                </ul>
                <p v-if="areaId == -1 && schools.length >= 10" class="tip">最多展示离你最近的10个学习中心</p>
            </div>
          </div>
      </div>
  </div>
</template>
<script>
import './AddressPicker.less'
import _ from 'lodash'
export default {
  name: 'AddressPicker',
  props: {
    currentAreaId: String,
    currentSchoolId: String,
    areaList: Array,
    schoolList: Array,
    myClosest: {
      type: Array,
      default(){
        return []
      }
    }
  },
  data(){
    return {
      areaId: '',
      schoolId: ''
    }
  },
  computed: {
      schools(){
        if (this.myClosest&&this.myClosest.length>0){
          return this.myClosest;
        } else if (this.areaId&&this.schoolList){
          return  _.find(this.schoolList, {id: this.areaId}).schools;
        } else {
          return [];
        }
      }
  },
  methods: {
    onAreaChange(area){
      this.areaId = area.id;
      this.$emit('onAreaIdChange', area.id);
    },
    onSchoolChange(school){
      this.schoolId = school.id
      this.$emit('onSchoolChange', school);
    },
    onCancelHandler(){
      this.$emit('cancel');
    },
    onCloseCenter(){
      this.$emit('close');
    },
    stopPropagation(e){
      e.stopPropagation();
    }
  },
  mounted(){
    this.areaId = this.currentAreaId;
    this.schoolId = this.currentSchoolId;
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/AddressPicker.vue